import {
    drawPointsAnim,
    drawLineAnim,
    drawCircleAnim,
    rotateCircleAnim,
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";

import { INITIAL_RADIANS } from "../../types/Config";
import { normalizeRadian } from "../../../../../../src/utils/math/normalizeRadian";
import { ContextType } from "../../types/Interface";
import { Coord } from "../../../../../../src/types/Interface";


export async function runCircleAnimation(context: ContextType, onComp: () => void) {
    const {
        circle,
        LineManager,
        PointManager,
        cCoord,
    } = context;

    const centerPoint = PointManager.getPoints()[0];
    const intersecPoint = PointManager.getIntersecPoint();
    const chordsCoords: Coord[][] = PointManager.getInitialChordCoords();
    const intersecCoord = PointManager.getInitialIntersecCoord(chordsCoords);
    const chordACoords = chordsCoords[0];
    const chordBCoords = chordsCoords[1];
    const RedPoints = PointManager.getRedPoints();
    const initialRadian = PointManager.getInitialRadians();
    PointManager.setIntersecPointVisible(false);
    PointManager.setIntersecPointInitial(intersecCoord);
    
    circle.setRadians([INITIAL_RADIANS[0], INITIAL_RADIANS[0]]);

    drawPointsAnim([centerPoint]);
    await drawCircleAnim(circle, INITIAL_RADIANS[0] + Math.PI * 2, 0, true, cCoord);
    await drawPointsAnim([intersecPoint]);
    await drawLineAnim(LineManager.lines[0], intersecCoord, chordACoords[2]);
    await drawLineAnim(LineManager.lines[2], intersecCoord, chordBCoords[0]);
    await rotateCircleAnim((v) => PointManager.setRadian(Array(2).fill("").map(((_, rI) => ({ pTag: RedPoints[rI].tag, radian: normalizeRadian(initialRadian[rI] + v) })))));

    onComp();
}